import { appContextStore } from "../../../common/redux/appContext";

const checkHighestQualifiedProductionType = (
  commission: number,
  premium: number,
  income: number
) => {
  const { applicationDefinition } = appContextStore.getState();

  const commissionMDRTThreshold =
    applicationDefinition.productionRequirements.mdrt.commission.total;
  const commissionCOTThreshold =
    applicationDefinition.productionRequirements.courtOfTable.commission.total;
  const commissionTOTThreshold =
    applicationDefinition.productionRequirements.topOfTable.commission.total;
  const premiumMDRTThreshold =
    applicationDefinition.productionRequirements.mdrt.premium.total;
  const premiumCOTThreshold =
    applicationDefinition.productionRequirements.courtOfTable.premium.total;
  const premiumTOTThreshold =
    applicationDefinition.productionRequirements.topOfTable.premium.total;
  const incomeMDRTThreshold =
    applicationDefinition.productionRequirements.mdrt.income.total;
  const incomeCOTThreshold =
    applicationDefinition.productionRequirements.courtOfTable.income.total;
  const incomeTOTThreshold =
    applicationDefinition.productionRequirements.topOfTable.income.total;

  let commissionQualifiedLevel = 0;
  let premiumQualifiedLevel = 0;
  let incomeQualifiedLevel = 0;

  if (commission >= commissionTOTThreshold) commissionQualifiedLevel = 3;
  else if (commission >= commissionCOTThreshold) commissionQualifiedLevel = 2;
  else if (commission >= commissionMDRTThreshold) commissionQualifiedLevel = 1;

  if (premium >= premiumTOTThreshold) premiumQualifiedLevel = 3;
  else if (premium >= premiumCOTThreshold) premiumQualifiedLevel = 2;
  else if (premium >= premiumMDRTThreshold) premiumQualifiedLevel = 1;

  if (income >= incomeTOTThreshold) incomeQualifiedLevel = 3;
  else if (income >= incomeCOTThreshold) incomeQualifiedLevel = 2;
  else if (income >= incomeMDRTThreshold) incomeQualifiedLevel = 1;

  return {
    commissionQualifiedLevel,
    premiumQualifiedLevel,
    incomeQualifiedLevel,
  };
};

export default checkHighestQualifiedProductionType;
